import { render, staticRenderFns } from "./ApprovalsTable.vue?vue&type=template&id=9ab6910a&scoped=true"
import script from "./ApprovalsTable.vue?vue&type=script&lang=ts"
export * from "./ApprovalsTable.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsTable.vue?vue&type=style&index=0&id=9ab6910a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab6910a",
  null
  
)

export default component.exports